
import { getTypesenseCategoryFilter } from '~~/helpers/category/getTypesenseCategoryFilter';

export const useIsOnCategory = () => {

  const route = useRoute();
  const { categories } = useCategories();
  const { categoryTree } = useCategoryTree();

  const isOnCategory = (): boolean => {

    if (!route.params.slug) {

      return false;

    }
    const categoryFilter = getTypesenseCategoryFilter({
      categorySlug: route.params.slug,
      categories: categories.value,
      categoryTree: categoryTree.value,
    });

    return !!categoryFilter;

  };

  return {
    isOnCategory,
  };

};
